// extracted by mini-css-extract-plugin
export default {"status":"status_status__VfIzX","--mobile":"status_--mobile__aF8Ae","--header":"status_--header__YQRlT"};